module.exports = __webpack_public_path__ + "media/images/kredit-dc44da44549b780c8631094ea6db0595.png";